import '../../../src/docReady.js';
import isMobile from '../../../src/isMobile.js';
import Helper from '../../../src/Helper.js'; // easing

import Easie from '../../../src/Easie.js'; // easing
import { getSlider } from 'simple-slider';

import 'fit-text-webcomponent';
import Dom from '../../../src/Dom.js';

import './style.scss';

const moduleSelector = '.eiovisual-slider1';

// _____________________________________________________________________________

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo slider1');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

// _____________________________________________________________________________

class ModuleFeature {
    
    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
        // Tasks on images
        setTimeout(() => { this.task1(); },0); // avvia lo slider
        setTimeout(() => { this.task2(); },250); // avvia fit-text
        setTimeout(() => { this.task3(); },2); // avvia lo spostamento del marker
    }
    
    // _________________________________________________________________________
    
    /**
     * Arriva da sx
     * @returns {undefined}
     */
    task1() {
       this.init_carousel(this.$module);
    }
    
    // _________________________________________________________________________

    /**
     * FIT-TEXT
     * @returns {undefined}
     */
    task2() {
        // seleziona gli elementi fit-text
        let $target = this.$module.querySelectorAll('.fit-text');
        
        // applica fit-text
        $target.forEach(($el,index) => {
            Dom.wrapInner($el,'fit-text');
        });
    }

    // _________________________________________________________________________
    
    task3() {
        this.move_marker(this.$categories[0],0);
    }

    /**
     * Inizializza categories
     * @returns {undefined}
     */
    init_categories() {
        this.$categories = this.$slideshow.parentNode.querySelectorAll('.categories .list .el');

        this.$categories.forEach(($category,i) => {
            this.config_category($category,i);
        });
    }

    // _________________________________________________________________________

    /**
     * Gestisce gli eventi della category
     * @param {type} $category
     * @param {type} i
     * @returns {undefined}
     */
    config_category($category,i) {
        $category.onclick = (e) => {
            
            let delay = parseFloat( this.$slideshow.getAttribute('data-delay').replace(/,/, '.')) * 1000;
            
            // se il coin non è attivo, è cliccabile
            if (!$category.classList.contains('active')) {
                this.Slider.change(i);
                
                var Slider = this.Slider;
                
                // pause and restart: reset timer
                this.Slider.pause();
                setTimeout( () => {
                    Slider.resume();
                }, delay );

            }
        };
    }
    
    // _________________________________________________________________________
    
    /**
     * Muove il marker
     * @param {type} $element
     * @param {type} delta
     * @returns {undefined}
     */
    move_marker($element,delta) {
        // sposta il marker
        let module_rect = this.$module.querySelector('.categories').getBoundingClientRect(); // posizione del modulo
        let el_rect = $element.getBoundingClientRect(); // posizione dell'elemento
        let marker_delta = (el_rect.left - module_rect.left) + ((el_rect.right - el_rect.left) / 2) + delta;
        this.$marker.style.left = marker_delta + 'px';
        this.$marker.style.transform = marker_delta + 'px';
    }
 
    // _________________________________________________________________________

    /**
     * Avvia il carousel
     * @param {type} $module
     * @returns {undefined}
     */
    init_carousel($module) {
        var that = this;
        this.$slideshow = $module.querySelector('.slides');
        this.$slides = this.$slideshow.querySelectorAll('.slide');
        this.$marker = $module.querySelector('.marker');  
        
        // avvia lo slider
        var SliderOptions = {
            container: this.$slideshow,                                                  // <Element> The HTML element that act as a container for the slider. Defaults to document.querySelector('*[data-simple-slider]).
            // children: container.children,                                        // <NodeList/Array> A list of children to be used as slides, you can use the querySelectorAll to have more flexibility on what children of the container element should be used as slides. Defaults to container.children.
            delay: parseFloat(this.$slideshow.getAttribute('data-delay').replace(/,/, '.')),                        // Value determining the wait between each animation when auto-transition is enabled. Defaults to 3 seconds.
            duration: parseFloat(this.$slideshow.getAttribute('data-duration').replace(/,/, '.')),               // Value setting the duration of animation transition. Defaults to 0.5.
            init: 100,                                                             // <String/Number> Initial value of slide elements when starting a transition animation. Defaults to -100.
            end: -100,                                                               // <String/Number> The value a slide will move to during a transition animation. Defaults to 100.
            unit: '%',                                                              // The css unit value to be used. Defaults to %.
            show: 0,                                                                // <String/Number> The value a slide element should have when it is displayed. Defaults to 0.
            paused: this.$slideshow.getAttribute('data-paused') | false,                 // Controls carousel auto-transition/slideshow. If value is true no transition will happen. Defaults to false.
            prop: this.$slideshow.getAttribute("data-direction"),                        // Determines the css property to be animated. Defaults to left.
            ease: Easie.cubicInOut,                                                 // An ease function, you can use any of these. Defaults to defaultEase internal function.
            onChange: (i) => {

                var next = that.Slider.nextIndex();

                // rimuove tutti gli active
                this.$categories.forEach(($category,i) => {
                    $category.classList.remove('active');
                });

                // sposta il marker
                this.move_marker(this.$categories[next],0);

                // aggiunge active alla slide corrente
                if(this.$slides[i].querySelector('.slide-content')) {
                    this.$slides[i].querySelector('.slide-content').classList.remove('active');     // Slide remove active
                }

                // aggiunge active sul current
                this.$categories[next].classList.add('active');     // Rimuove active dalla slide in uscita

                if(this.$slides[next].querySelector('.slide-content')) {
                    this.$slides[next].querySelector('.slide-content').classList.add('active');       // Slide active
                }

            }, // A callback function to be invoked each time a slide changes.
            onChangeEnd: (i) => {



            } // A callback function to be invoked at the end of the slide transition
        };

        // run simple-slider
        // https://github.com/ruyadorno/simple-slider
        this.Slider = getSlider(SliderOptions);
        
        this.init_categories();
    }
    
    // _________________________________________________________________________
    
   
}

// _____________________________________________________________________________

// export
export default new Module();
    
// _____________________________________________________________________________